import type { SelectOption } from '@/shared/ui/selectTypes';

interface OptionSource {
  id: string | number;
  name?: string;
  title?: string;
  code?: string;
}

export const toOptions = (items: OptionSource[] = []): SelectOption[] =>
  items.map((item) => ({
    value: String(item.id),
    label: String(item.name ?? item.title ?? item.code ?? item.id),
  }));
